import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./component/Header";
import DataTable from "./component/DataTable";
import { useDispatch, useSelector } from "react-redux";
import AddUpdateModal from "../AddUpdateModal";
import {
  getTimeZonesById,
  redirectToTimeZonesList,
  timeZonesListFetch,
  deleteApplications,
} from "actions";

const TimezoneList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const session = useSelector((state) => state.session);
  const timeZonesState = useSelector((state) => state.timeZonesState);
  const [filterQuery, setFilterQuery] = useState("");
  const [editModalShow, setEditModalShow] = useState(false);
  const [DeletemodalShow, DeletesetModalShow] = useState(false);

  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  useEffect(() => {
    dispatch(timeZonesListFetch(object_viewed_id));
  }, []);

  // Check if the update form needs to be shown
  useEffect(() => {
    if (timeZonesState.showUpdateForm) {
      setEditModalShow(true);
    } else {
      setEditModalShow(false);
    }
  }, [timeZonesState.showUpdateForm]);

  // Redirect to update form
  const showUpdateForm = (recordId) => {
    console.log("Record ID for update:", recordId);
    dispatch(getTimeZonesById(recordId, "update"));
  };

  // Hide model when needed
  const hideEditModal = () => {
    setEditModalShow(false);
    dispatch(redirectToTimeZonesList());
  };

  return (
    <>
      <div>
        <Header
          filterQuery={filterQuery}
          setFilterQuery={setFilterQuery}
          setEditModalShow={setEditModalShow}
        />
        <DataTable
          filterQuery={filterQuery}
          editModalShow={editModalShow}
          setEditModalShow={setEditModalShow}
          DeletemodalShow={DeletemodalShow}
          showUpdateForm={showUpdateForm}
          DeletesetModalShow={DeletesetModalShow}
        />
      </div>
      <AddUpdateModal show={editModalShow} onHide={hideEditModal} />
    </>
  );
};

export default TimezoneList;
